namespace TabAurous.ECommerce {
    export interface ECommOrderForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        ECommOrderId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        ECommOrderNo: Serenity.StringEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        PartyId: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        BillingAddress: Serenity.StringEditor;
        BillingCountryName: Serenity.StringEditor;
        BillingStateName: Serenity.StringEditor;
        BillingCityName: Serenity.StringEditor;
        BillingPin: Serenity.StringEditor;
        BillingPhone: Serenity.StringEditor;
        BillingCity: Serenity.IntegerEditor;
        BillingState: Serenity.IntegerEditor;
        BillingCountry: Serenity.IntegerEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        ShippingAddress: Serenity.StringEditor;
        ShippingCountry: Serenity.LookupEditor;
        ShippingState: Serenity.LookupEditor;
        ShippingCity: Serenity.LookupEditor;
        ShippingPincode: Serenity.StringEditor;
        ShippingPhone: Serenity.StringEditor;
        ShippingCityName: Serenity.StringEditor;
        ShippingStateName: Serenity.StringEditor;
        ShippingCountryName: Serenity.StringEditor;
        ItemDetails: ECommOrderItemsEditor;
        PromoDetails: ECommOrderPromoEditor;
        ReceiptDetails: Retail.ReceiptDetailsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        ReceiptAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
    }

    export class ECommOrderForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.Order';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommOrderForm.init)  {
                ECommOrderForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = ECommOrderItemsEditor;
                var w8 = ECommOrderPromoEditor;
                var w9 = Retail.ReceiptDetailsEditor;
                var w10 = s.TextAreaEditor;

                Q.initFormType(ECommOrderForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'ECommOrderId', w1,
                    'VoucherNo', w1,
                    'ECommOrderNo', w1,
                    'POSCustomerId', w2,
                    'PartyId', w3,
                    'CustomerName', w1,
                    'Mobile', w1,
                    'Email', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w4,
                    'ExchRate', w5,
                    'UserId', w4,
                    'EmployeeId', w3,
                    'ProductItemImage', w6,
                    'BillingAddress', w1,
                    'BillingCountryName', w1,
                    'BillingStateName', w1,
                    'BillingCityName', w1,
                    'BillingPin', w1,
                    'BillingPhone', w1,
                    'BillingCity', w3,
                    'BillingState', w3,
                    'BillingCountry', w3,
                    'VoucherTypeId', w3,
                    'ShippingAddress', w1,
                    'ShippingCountry', w4,
                    'ShippingState', w4,
                    'ShippingCity', w4,
                    'ShippingPincode', w1,
                    'ShippingPhone', w1,
                    'ShippingCityName', w1,
                    'ShippingStateName', w1,
                    'ShippingCountryName', w1,
                    'ItemDetails', w7,
                    'PromoDetails', w8,
                    'ReceiptDetails', w9,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w5,
                    'NetWeight', w5,
                    'NetAmount', w5,
                    'ReceiptAmount', w5,
                    'Discount', w5,
                    'AdditionalCharges', w5,
                    'GrossAmount', w5,
                    'Remark', w10,
                    'ShipAddressId', w3,
                    'CompanyId', w3,
                    'ShipmentId', w3
                ]);
            }
        }
    }
}
